import React, { useState, useEffect } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate } from "../../util/global";


const AppointmentForm = ({ showmodal, setshowmodal, formdata, setformdata, handlesubmit, contactmap, appointmentdata, isvaliddatetime }) => {
  const [showdropdown, setshowdropdown] = useState(false);
  const [suggestions, setsuggestions] = useState([]);

    useEffect(() => { 
      console.log("FORM USE EFFECT AppointmentForm");
      $( ".date" ).datepicker({
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        yearRange: "0:+50",
        dateFormat: "M dd yy",
        minDate : 1,
        onSelect: (datetext) => {
        const date = getdate(datetext).datestr;
      
        setformdata(prev => ({
          ...prev, 
          datestr: datetext,
          date: date
        }));
      }
      });
    }, [showmodal]);

  if (!showmodal) return null;

  const handlenameinput = (val) => {
    setformdata({ ...formdata, name: val });
    
    if (val.length > 0) {
      // Filter the map keys for matches
      const matches = Array.from(contactmap.keys()).filter(name => 
        name.toLowerCase().includes(val.toLowerCase())
      );
      setsuggestions(matches);
      setshowdropdown(true);
    } else {
      setshowdropdown(false);
    }
  };
  
  const selectcontact = (name) => {
    const phone = contactmap.get(name);
    // SERIAL UPDATE: Update both fields and close list immediately
    setformdata({ ...formdata, name: name, phonenumber: phone || formdata.phonenumber });
    setshowdropdown(false);
  };

  let currdate = new Date();
  if (!formdata.date) {
    currdate = currdate.toISOString().split("T")[0].split(" ");
    formdata.date = currdate.reverse().join("-");
  }
  
  let availabletime = [];
  const updateavailabletime = () => {
    console.log("updateaailabletime CALLED");
    availabletime = TIMEDATA.filter((time) => {
      let currdatetime = formdata.date + "T" + time;
      return isvaliddatetime(currdatetime);
    });

    if (availabletime.length == 0) {
      let date = new Date(formdata.date);

      let closedata = CLOSEDDATA.filter((c) => {
        const startdate = new Date(c.startdate);
        const enddate = new Date(c.enddate);
        return date.getTime() >=  startdate.getTime() && date.getTime() <= enddate.getTime();
      });
      alert("Clinic is closed on the following dates " + JSON.stringify(closedata));
    }
  };
  updateavailabletime();

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "Edit Appointment" : "Book New Appointment"}</h3>
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Date</label>
            <div style={{ position: 'relative' }}>
                
              <input type="text" className="form-input date" value={formdata.datestr} id="date"
                  onChange={(e) => {alert('test');formdata.datestr = e.target.value;formdata.date = getdate(formdata.datestr).datestr;updateavailabletime();} }
              />
            </div>
          </div>

          <div className="form-group">
            <label>Time Slot</label>
            <select className="form-input" value={formdata.time} onChange={(e) => setformdata({...formdata, time: e.target.value})}>
              <option value="">Select Time</option>
              {availabletime.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div className="form-group" style={{ position: "relative" }}>
            <label>Name</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.name} 
              onChange={(e) => handlenameinput(e.target.value)}
              onBlur={() => setTimeout(() => setshowdropdown(false), 200)}
              autoComplete="off"
            />
            {showdropdown && suggestions.length > 0 && (
              <div className="autocomplete-dropdown" style={{
                position: "absolute", top: "100%", left: 0, right: 0,
                background: "white", border: "1px solid #ccc", zIndex: 1000,
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}>
                {suggestions.map(name => (
                  <div 
                    key={name} 
                    onMouseDown={() => selectcontact(name)} // Use onMouseDown to beat the onBlur
                    style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                  >
                    {name}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.phonenumber} 
              onChange={(e) => setformdata({...formdata, phonenumber: e.target.value})} 
            />              
          </div>

          <div className="form-group">
            <label>Message / Note</label>
            <input type="text" className="form-input" value={formdata.comment} onChange={(e) => setformdata({...formdata, comment: e.target.value})} />
          </div>

          <button className="btn-blue full-width" onClick={handlesubmit}>
            {formdata._id ? "Update" : "Submit & Pay"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentForm;